module.exports = __webpack_public_path__ + "fonts/icomoon.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/icomoon/icomoon.woff?1ki0q8
// module id = 399
// module chunks = 0